import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../../common/api";
import {
  Button,
  IconButton,
  InputAdornment,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ServiceChargeVehicles = ({ id }) => {
  const [contract, setContract] = useState({ vehicles: [] });
  const [vehicles, setVehicles] = useState([]);
  const [client, setClient] = useState({});
  const [serviceCharge, setServiceCharge] = useState({ vehicles: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    severity: "success"
  });

  const token = localStorage.getItem("userToken");
  const fetchServiceCharge = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(api.service().getServiceCharge(id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServiceCharge(res.data);
      fetchContract(res.data.contract_id);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      // setIsLoading(false);
    }
  };
  const fetchContract = async contract_id => {
    setIsLoading(true);
    try {
      const res = await axios.get(api.contract().get(contract_id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContract(res.data[0]);
      if (res.data[0].contract_type_id === 2) {
        fetchClient(res.data[0].contact_id);
      } else {
        setVehicles(res.data[0].vehicles);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching contract:", error);
    } finally {
      //setIsLoading(false);
    }
  };

  const fetchClient = async contact_id => {
    setIsLoading(true);
    try {
      const res = await axios.get(api.contacts().get(contact_id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClient(res.data);
      fetchBookingVehicles(res.data.client.id);
    } catch (error) {
      console.error("Error fetching client:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchBookingVehicles = async client_id => {
    setIsLoading(true);
    try {
      const res = await axios.get(api.clients().getVehicles(client_id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicles(res.data);
    } catch (error) {
      console.error("Error fetching booking vehicles:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchServiceCharge();
  }, []);

  const handleSubmit = async () => {
    setSaving(true);
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("service_change[id]", serviceCharge.id);
    serviceCharge.vehicles
      .filter(v => v.vehicle && v.vehicle.plate != "")
      .forEach((vehicle, index) => {
        formData.append(
          `service_change[vehicles][${index}][vehicle_id]`,
          vehicle.vehicle_id
        );

        formData.append(
          `service_change[vehicles][${index}][start_date]`,
          vehicle.start_date ? vehicle.start_date : ""
        );
        formData.append(
          `service_change[vehicles][${index}][end_date]`,
          vehicle.end_date ? vehicle.end_date : ""
        );
        if (vehicle.id) {
          formData.append(`service_change[vehicles][${index}][id]`, vehicle.id);
        } else {
          formData.append(`service_change[vehicles][${index}][id]`, 0);
        }
      });
    return axios
      .post(
        api.service().addVehiclesToServiceCharge(serviceCharge.id),
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      .then(res => {
        setSnackbar({
          open: true,
          message: "Cargo actualizado con exito",
          severity: "success"
        });
        setSaving(false);
        fetchServiceCharge(serviceCharge.id);
      })
      .catch(err => {
        const { errors } = err.response.data;
        let error_msg = "";
        if (errors) {
          for (let key in errors) {
            error_msg += errors[key];
          }
          setSnackbar({
            open: true,
            message: error_msg,
            severity: "error"
          });
          setSaving(false);
        } else {
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al guardar los cambios",
            severity: "error"
          });
          setSaving(false);
        }
      });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="row">
      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        className="alert-fix"
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <div className="col-12">
        <p className="mb-0">{contract.name}</p>
        <h5>
          Cargo{" "}
          {serviceCharge.charge_type ? serviceCharge.charge_type.name : ""}
        </h5>
      </div>
      <div className="col-3">
        <TextField
          id="value"
          name="value"
          margin="normal"
          disabled
          className="ml-2 mt-2"
          InputLabelProps={{
            shrink: true
          }}
          value={serviceCharge.value}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Monto</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        />
      </div>

      <div className="col-3">
        <TextField
          id="start_date"
          name="start_date"
          margin="normal"
          disabled
          className="ml-2 mt-2"
          InputLabelProps={{
            shrink: true
          }}
          value={serviceCharge.start_date}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Inicio</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        />
      </div>
      <div className="col-3">
        <TextField
          id="end_date"
          name="end_date"
          margin="normal"
          disabled
          className="ml-2 mt-2"
          InputLabelProps={{
            shrink: true
          }}
          value={serviceCharge.end_date}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Fin</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        />
      </div>
      <div className="col-md-12">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="p-0">Patente</TableCell>
              <TableCell className="p-0">Fecha inicio</TableCell>
              <TableCell className="p-0">Fecha fin</TableCell>
              <TableCell className="p-0">
                {vehicles && vehicles.length > 0 && (
                  <IconButton
                    onClick={() => {
                      const newVehicle = {
                        id: 0,
                        vehicle: { plate: "" },
                        vehicle_id: 0,
                        start_date: new Date().toISOString().split("T")[0],
                        end_date: ""
                      };
                      setServiceCharge({
                        ...serviceCharge,
                        vehicles: [...serviceCharge.vehicles, newVehicle]
                      });
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceCharge.vehicles &&
              serviceCharge.vehicles.map((vehicle, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className="p-0">
                      <TextField
                        id="vehicle_plate"
                        name="vehicle_plate"
                        margin="normal"
                        className="ml-auto"
                        InputLabelProps={{
                          shrink: true
                        }}
                        select={vehicle.id > 0 ? false : true}
                        disabled={vehicle.id > 0 ? true : false}
                        onClick={event => {
                          const vehicle = vehicles.find(
                            v => v.plate === event.target.value
                          );
                          setServiceCharge({
                            ...serviceCharge,
                            vehicles: serviceCharge.vehicles.map((v, i) =>
                              i === index
                                ? {
                                    ...v,
                                    vehicle_id: vehicle.id,
                                    vehicle: { plate: event.target.value }
                                  }
                                : v
                            )
                          });
                        }}
                        value={vehicle.vehicle.plate}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography variant="caption">Patente</Typography>
                            </InputAdornment>
                          ),
                          style: { fontSize: "0.75rem" }
                        }}
                      >
                        {vehicles.map((vehicle, index) => (
                          <MenuItem
                            key={index}
                            value={vehicle.plate}
                            style={{ fontSize: "0.7rem" }}
                          >
                            {vehicle.plate}
                          </MenuItem>
                        ))}
                      </TextField>
                    </TableCell>
                    <TableCell className="p-0">
                      <TextField
                        id="start_date"
                        name="start_date"
                        type="date"
                        margin="normal"
                        className="ml-2"
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={vehicle.start_date}
                        onChange={event => {
                          setServiceCharge({
                            ...serviceCharge,
                            vehicles: serviceCharge.vehicles.map((v, i) =>
                              i === index
                                ? { ...v, start_date: event.target.value }
                                : v
                            )
                          });
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography variant="caption">Inicio</Typography>
                            </InputAdornment>
                          ),
                          style: { fontSize: "0.75rem" }
                        }}
                      />
                    </TableCell>
                    <TableCell className="p-0">
                      <TextField
                        id="end_date"
                        name="end_date"
                        type="date"
                        margin="normal"
                        className="ml-2"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={event => {
                          setServiceCharge({
                            ...serviceCharge,
                            vehicles: serviceCharge.vehicles.map((v, i) =>
                              i === index
                                ? { ...v, end_date: event.target.value }
                                : v
                            )
                          });
                        }}
                        value={vehicle.end_date}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography variant="caption">Fin</Typography>
                            </InputAdornment>
                          ),
                          style: { fontSize: "0.75rem" }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}

            {serviceCharge.vehicles.length === 0 && (
              <TableRow>
                <TableCell colSpan={3}>
                  <p>No hay vehículos asociados</p>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <div className="col-md-12 mt-2">
        <Button
          onClick={() => {
            handleSubmit();
          }}
          color="primary"
          variant="contained"
          disabled={saving}
          size="small"
          className="mr-2"
        >
          Guardar
        </Button>
        <Button
          onClick={() => {
            window.history.back();
          }}
          variant="outlined"
          color="secondary"
          size="small"
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
};

export default ServiceChargeVehicles;
